/*jshint esversion: 6 */
/*jshint strict:false */
import { format } from 'date-fns';
import { customEvent, generateLeadEvent } from '../../../modules/tracking/AnalyticsEvents';


const getDefaultState = () => {
    return {
        step: 1,
        registration: "",
        mileage: "",
        notMyVehicle: false,
        otherSelected: false,
        nonFranchiseVehicle: {},
        hasUkVehicleData: '',
        selectedVehicle: {
            image_url: ""
        },
        vehicleImage: '',
        selectedDate: null,
        selectedTime: null,
        bookingDetails: null,
        customerData: {},
        valuationHasError: false,
        valuation: {
            basic: null,
            service_history:null,
            mechanical_condition:null,
            tchek:null,
            final:null,
        },
        valuationLogId: '',
        useSpecificDealer: false,
        selectedDealer: '',
        goToWidgetPosition: false,
        bookingExists: false,
        bookingExistsMessage: "",
        loading: false,
        loadingValuationData: false,
        usedVehicleID: null,
        newVehicleID: null,
        newModelID: null,
        displayBookAppointment:false,
        enquiryMaxValuationID: null,
        enquiryMaxWarning: false,
        isDealer:false
    };
};

const state = getDefaultState();

const mutations = {
    setStep(state, step) {
        state.step = step;
    },
    incrementStep(state) {
        state.step += 1;
    },
    setSelectedVehicle(state, data) {
        state.selectedVehicle = data;
    },
    setRegistration(state, registration) {
        state.registration = registration;
    },
    setMileage(state, mileage) {
        state.mileage = mileage;
    },

    setSelectedDate(state, date) {
        state.selectedDate = date;
    },
    setSelectedTime(state, time) {
        state.selectedTime = time;
    },
    setNotMyVehicle(state, value) {
        state.notMyVehicle = value;
    },
    setOtherSelected(state, value) {
        state.otherSelected = value;
    },
    setHasUkVehicleData(state, value) {
        state.hasUkVehicleData = value;
    },
    setNonFranchisedVehicle(state, data) {
        state.nonFranchiseVehicle = data;
    },
    setValuationBasic(state, data) {
        state.valuation.basic = data;
    },
    setValuation(state, data) {
        state.valuation = data;
    },
    setValuationHasError(state, hasError) {
        state.valuationHasError = hasError == true ? true : false;
    },
    setValuationFinalAmount(state, data) {
        state.valuation.final = data;
    },
    // setStateForNotMyVehicle(state) {
    //     state.selectedVehicle = {
    //         fuel_type: "",
    //         image_url: "",
    //         make: "",
    //         model: "",
    //         registration: state.registration,
    //         year_of_manufacture: ""
    //     };
    //     state.motExpiryKnown = false;
    //     state.motDue = true;
    // },
    setSelectedDealer(state, data) {
        state.selectedDealer = data;
    },
    setBookingDetails(state, data) {
        state.bookingDetails = data;
    },
    setCustomerData(state, customerData) {
        state.customerData = customerData;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setGoToWidgetPosition(state, data) {
        state.goToWidgetPosition = data;
    },
    setBookingExistsMessage(state, data) {
        state.bookingExistsMessage = data;
    },
    setBookingExists(state, data) {
        state.bookingExists = data;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoadingValuationData(state, loadingValuationData) {
        state.loadingValuationData = loadingValuationData;
    },
    setUseSpecificDealer(state, useSpecificDealer) {
        state.useSpecificDealer = useSpecificDealer;
    },
    setUsedVehicleID(state, usedVehicleID) {
        state.usedVehicleID = usedVehicleID;
    },
    setNewVehicleID(state, newVehicleID) {
        state.newVehicleID = newVehicleID;
    },
    setNewModelID(state, newModelID) {
        state.newModelID = newModelID;
    },

    setValuationData(state, responseData) {
        try {
            state.step = responseData.complete ? 2 : 1;
            state.registration = responseData.reg_no || "";
            state.mileage = responseData.mileage || "";
            const vehicleInfo = JSON.parse(responseData.vehicle_info || '{}');
            state.selectedVehicle = {
                image_url: vehicleInfo.image || responseData.image_url || "/images/no-image-available.png",
                make: vehicleInfo.make || responseData.make,
                model: vehicleInfo.model || responseData.model,
                body_type: vehicleInfo.bodyType || responseData.body_type,
                derivative: vehicleInfo.derivativeName || responseData.derivative,
                engine_size: vehicleInfo.engineSize || responseData.engine_size,
                fuel_type: vehicleInfo.fuelType || responseData.fuel_type,
                transmission: vehicleInfo.transmission || responseData.transmission,
                first_registered: format(vehicleInfo.dateOfRegistration, "DD-MM-YYYY") ||  responseData.first_registered,
                hide_timing_kit: vehicleInfo.hideTimingKit || responseData.hide_timing_kit,
                battery_range_miles: vehicleInfo.batteryRangeMiles|| responseData.battery_range_miles,
                customer_name: vehicleInfo.customerName || responseData.customer_name,
            };
            state.valuation = responseData.valuation_amounts;
            state.valuationLogId = responseData.id;
            state.valuationHasError = false;
        } catch (error) {
            console.error("Error parsing valuation data:", error);
            state.valuationHasError = true;
        }
    },


    setDisplayBookAppointment(state, display){
        state.displayBookAppointment = display;
    },

    setEnquiryMaxValuationID(state, enquiryMaxValuationID){
        state.enquiryMaxValuationID = enquiryMaxValuationID;
    },

    setEnquiryMaxWarning(state, warning){
        state.enquiryMaxWarning = warning == true ? true : false;
    },

    setIsDealer(state, isDealer){
        state.isDealer = isDealer;
    },

    setValuationLogId(state, data){
        state.valuationLogId = data;
    }
};

const actions = {
    useSpecificDealer({ dispatch, commit }, specificDealer) {
        const options = {
            getAddressInfo: true,
            getPhoneInfo: true,
        };
        dispatch('Dealers/getDealers', options, { root: true }).then(dealers => {
            specificDealer = parseInt(specificDealer)
            const selectedDealer = dealers.find(dealer => dealer.id === specificDealer);
            commit('Dealers/setSelectedDealer', selectedDealer, { root: true });
            commit('setUseSpecificDealer', selectedDealer);
        })
    },

    manualVehicleSearch({ commit, dispatch }, data) {
        commit('setOtherSelected', true);
        dispatch('Auth/checkAuthenticated', {}, { root: true })
        commit('setStep', 2)
    },

    confirmVehicle({ commit, dispatch, state }) {
        dispatch('checkIfVehicleIsRegistered')
        commit('incrementStep')
        commit('setStep', state.step)
    },

    checkIfVehicleIsRegistered({ dispatch }) {
        return new Promise((resolve, reject) => {
            dispatch('Auth/registeredVehicle', {
                vehicleReg: state.registration
            }, { root: true })
        });
    },

    previousStep({ commit, state }, data) {
        if (state.step === 2) {
            commit('setOtherSelected', false);
            if (state.notMyVehicle === true) {
                commit('setNotMyVehicle', false);
            } else {
                commit('resetState');
            }
        }else if (state.step === 6){
            commit('setStep', 4)
        }
        else {
            commit('setStep', data);
        }
    },

    updateNonFranchiseVehicleDetails({ state, rootState, commit }, data) {
        if (state.hasUkVehicleData === false) {
            let vehicleDetails = {
                'reg_no': state.registration,
                'mileage': state.mileage
            }
            data = { ...data, ...vehicleDetails };
        } else {
            commit('setRegistration', null)
            commit('setMileage', null)
        }
        commit('setSelectedVehicle', null)

        if (rootState.Auth.vehicleRegistered === true) {
            commit('Auth/setVehicleRegistered', false, { root: true });
        }

        commit('setNonFranchisedVehicle', data)
        commit('setStep', 3)
    },

    findMyCar({ commit, state, dispatch }, data) {
        return new Promise((resolve, reject) => {
            commit('setRegistration', data.registration);
            commit('setMileage', data.mileage);
            commit('setEnquiryMaxWarning', false);
            axios({
                method: "POST",
                url: `/valuation/vehicle-info`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: {
                    reg_no: state.registration,
                    mileage: state.mileage
                },
            })
                .then(response => {
                    dispatch('parseUkVehicleData', response.data)
                    dispatch('Auth/checkAuthenticated', {}, { root: true })

                    // commit('setEnquiryMaxValuationID', '62956bdc-c8ec-422f-9508-def473c9a997');
                    if (typeof response.data['is_dealer']) {
                        commit('setIsDealer', response.data['is_dealer']);
                    }
                    if (typeof response.data['enquiry_max_valuation_id']) {
                        commit('setEnquiryMaxValuationID', response.data['enquiry_max_valuation_id']);
                    }
                    if (typeof response.data['enquiry_max_warning']) {
                        commit('setEnquiryMaxWarning', response.data['enquiry_max_warning']);
                    }
                    resolve(response);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });
    },

    parseUkVehicleData({ commit }, data) {
        if (typeof data.info === 'undefined') {
            commit('setHasUkVehicleData', false)
            return;
        }
        const isAllEmptyExceptFirstRegistered = Object.keys(data.info).every(key => {
            return key === 'first_registered' || data.info[key] === '';
        });
        if (isAllEmptyExceptFirstRegistered) {
            commit('setHasUkVehicleData', false);
            return;
        }

        if (typeof data.image !== 'undefined' && data.image !== '') {
            data.info.image_url = data.image;
        }
        commit('setSelectedVehicle', data.info);
        commit('setHasUkVehicleData', true);
    },

    submitValuation({ state, dispatch, commit }, formData) {
        let customerDetails = Object.fromEntries(formData);
        commit('setCustomerData', customerDetails);

        if (state.useSpecificDealer === false) {
            const locationId = parseInt(formData.get('location-id'));
            const options = {
                getAddressInfo: true,
                getPhoneInfo: true,
            };
            dispatch('Dealers/getDealers', options, { root: true }).then(dealers => {
                const selectedDealer = dealers.find(dealer => dealer.id === locationId);
                commit('Dealers/setSelectedDealer', selectedDealer, { root: true });
            })
        } else {
            formData.append('location-id', state.useSpecificDealer.id);
        }

        if (state.usedVehicleID !== null) {
            formData.append('used_vehicle', state.usedVehicleID);
        }
        if (state.newVehicleID !== null) {
            formData.append('new_vehicle', state.newVehicleID);
        }
        if (state.newModelID !== null) {
            formData.append('new_model', state.newModelID);
        }

        return dispatch(state.otherSelected || state.hasUkVehicleData !== true ? 'getManualValuation' : 'getValuation', formData);
    },

    async getDealerSpecificValuation({ dispatch, state }) {
        try {
            const response = await dispatch('fetchValuation', {
                url: '/valuation/submit-dealer',
                data: {
                    reg_no: state.registration,
                    mileage: state.mileage,
                    enquiry_max_valuation_id: state.enquiryMaxValuationID,
                    is_dealer: state.isDealer,
                },
                actionType: 'dealerLookup'
            });
            return response;
        } catch (error) {
            console.error("Error fetching valuation:", error);
            throw error;
        }
    },

    async getValuation({ commit, dispatch }, data) {
        data.append('requestUrl', window.location.href)
        try {
            const response = await dispatch('fetchValuation', {
                url: '/valuation/submit',
                data: data,
                actionType: 'getValuation'
            });
            return response;
        } catch (error) {
            console.error("Error fetching valuation:", error);
            throw error;
        }
    },

    getManualValuation({ dispatch, state }, data) {
        let nonFranchiseVehicle = state.nonFranchiseVehicle
        for (const [key, value] of Object.entries(nonFranchiseVehicle)) {
            data.set(key, value);
        }
        return dispatch('fetchValuation', {
            url: '/valuation/manual-lookup',
            data: data,
            actionType: 'getManualValuation'
        });
    },

    fetchValuation({ commit }, { url, data, actionType }) {
        return new Promise((resolve, reject) => {
            axios({
                method: "POST",
                url: url,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: data
            })
                .then(response => {
                    if (actionType === 'getValuation') {
                        commit('setValuationData', response.data.valuation_log);
                        commit('setStep', 4);
                        customEvent('Valuation', 'Vehicle Valuation', 'Complete');
                        generateLeadEvent('valuation_complete');
                    } else if (actionType === 'getManualValuation') {
                        commit('setValuation', false);
                        commit('setStep', 5);
                        customEvent('Valuation', 'Manual Lookup', 'Complete');
                        generateLeadEvent('valuation_manual_lookup');
                    } else if (actionType === 'dealerLookup') {
                        commit('setValuationBasic', response.data.valuation.valuation);
                        commit('setValuationLogId', response.data.valuation.log_id);
                        commit('setStep', 6);
                        // customEvent('Valuation', 'Dealer Specific Lookup', 'Complete');
                        // generateLeadEvent('valuation_manual_lookup');
                    }
                    resolve(response);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });
    },

    async bookAppointment({ commit, state, dispatch, rootState }) {
        reCaptchaProtect(async () => {
            commit('setLoading', true);
            // if step ten store valuation for un registered user
            if(rootState.Auth.authenticated === false && state.step === 10){
                try {
                    await dispatch('ValuationExtended/storeValuation', false, { root: true });
                }catch{
                    console.error("Error saving valuation:", error);
                }
            }
            const customerData = state.customerData;
            const vehicle = {
                'reg_no': state.registration,
                'mileage': state.mileage,
            };
            const dateTime = {
                'appointment_date': state.selectedDate,
                'appointment_time': state.selectedTime
            };
            const appointmentData = { ...customerData, ...dateTime, ...vehicle };
            appointmentData['location-id'] = rootState.Dealers.selectedDealer;
            appointmentData['valuation_log_id'] = rootState.ValuationExtended.valuationLogId ?? state.valuationLogId;
            
            try {
                const existingBookingFound = await dispatch('checkForExistingBooking');
                if (!existingBookingFound) {
                    const response = await axios.post(`/valuation/book-appointment`, appointmentData);
                    commit('setBookingDetails', response.data);
                }
                commit('setLoading', false)
                
            } catch (error) {
                console.error("Error booking appointment:", error);
                throw error;
            }
        });
    },

    async checkForExistingBooking({ commit, state, rootState }) {
        try {
            const response = await axios.post("/valuation/existing-booking", {
                registration: state.registration,
                date: format(state.selectedDate, "YYYY-MM-DD HH:mm:ss"),
                time: state.selectedTime,
                locationId: rootState.Dealers.selectedDealer,
            });

            if (response.data.record_found !== false && response.data.record_found >= 0) {
                commit('setBookingExists', true);
                commit('setBookingExistsMessage', "A booking already exists for this vehicle with the selected dealer made within last 30 days.");
                return true;
            } else {
                commit('setBookingExists', false);
                commit('setBookingExistsMessage', "");
                return false;
            }
        } catch (error) {
            console.error("Error checking existing booking:", error);
            throw error;
        }
    },

    goToPosition({commit}, position) {
        const targetElement = document.getElementById(position);
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - 60;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    },

    async newValuation({ commit, dispatch}) {
        await dispatch('ValuationExtended/clearSession', ['valuation_data', 'extended_valuation_data', 'valuation_log_id'], { root: true });
        commit('resetState');
        commit('setGoToWidgetPosition', true)
        // Check if the URL contains "car-valuation" and "valuation" as this will be a continued valuation from "my account"
        const urlParams = new URLSearchParams(window.location.search);
        const valuationId = urlParams.get('valuation');
        if (window.location.pathname.includes('/car-valuation') && valuationId) {
            window.location.href = '/car-valuation';
        }
        // For other pages remove query params
        if(urlParams.has('valuation') && urlParams.has('tchek')){
            const url = window.location.origin + window.location.pathname
            window.location.href = url;
        }
    },

    goToExtendedValuation({ commit }) {
        commit('ValuationExtended/setValuationLogId', state.valuationLogId, { root: true });
        commit('setStep', 6)
    }
};

const getters = {
    valuation_log_id: state => state.valuationLogId,
    registration: state => state.registration,
    mileage: state => state.mileage,

    vehicleImage(state) {
        if (state.otherSelected || !state.selectedVehicle || !state.selectedVehicle.image_url) {
            return '/images/service-and-parts/osb/image-not-available@2x.png';
        }

        return state.selectedVehicle.image_url;
    },

    bookingDetailsFormatted(state) {
        if (!state.selectedDate) return '';
        let date = format(new Date(state.selectedDate), 'ddd Do MMM YYYY');
        return {
            date: date,
            time: state.selectedTime || ''
        };
    },

    vehicleDetailsFormatted(state) {
        return {
            'registration': state.registration,
            'mileage': state.mileage,
            'make': state.selectedVehicle.make ?? null,
            'model': state.selectedVehicle.model ?? null,
            'derivative': state.selectedVehicle.derivative || '',
            'fuel-type': state.selectedVehicle.fuel_type,
            'next-mot-due-date': state.selectedVehicle.next_mot_due_date || 'none',
            'year-of-manufacture': state.selectedVehicle.year_of_manufacture ?? null,
            'image-url': state.selectedVehicle.image_url ? state.selectedVehicle.image_url : false,
        };
    },

    nonUkVehicleDataFormatted(state) {
        return {
            'registration': state.registration,
            'mileage': state.mileage,
            'make': state.nonFranchiseVehicle.make ?? null,
            'model': state.nonFranchiseVehicle.model ?? null,
            'image-url': state.nonFranchiseVehicle.image_url ? state.nonFranchiseVehicle.image_url : false,
        };
    },

    getValuation(state){
        return state.valuation
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./resources/assets/js/valuation-tool/store/modules/valuation-tool.js